import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import React, { useEffect, useState } from 'react';
import { getAllCategoriesWithoutFilters } from '../../../api/carteleriaApi';
import { CategoryTreeItem } from './CategoryTreeItem';

const WITHOUT_CATEGORY_VALUE = 'SIN_CATEGORIA';

export const CategoryTree = ({ categorySelectedToCkeckBox, setCategorySelectedToCkeckBox }) => {
  const [newCategories, setNewCategories] = useState(null);
  const { getAccessTokenSilently } = useAuth0();
  const { data: allCategoriesTotal, isFetching } = useQuery(['allCategoriesTotal'], async () => {
    const token = await getAccessTokenSilently();
    return await getAllCategoriesWithoutFilters(token);
  });

  useEffect(() => {
    if (!allCategoriesTotal) return;
    const superTransform = transformCategories(allCategoriesTotal);
    setNewCategories(superTransform);
  }, [allCategoriesTotal]);

  const transformCategories = (categories) => {
    const parentCategories = categories.filter((category) => !category.parentCategory);

    const getSubCategories = (parentId) => {
      return categories
        .filter((category) => category.parentCategory === parentId)
        .map((category) => ({
          ...category,
          children: getSubCategories(category._id),
        }));
    };

    const transformedCategories = parentCategories.map((category) => ({
      ...category,
      children: getSubCategories(category._id),
    }));

    return transformedCategories;
  };

  const handleWithoutCategoryChange = () => {
    const isSelected = categorySelectedToCkeckBox?.includes(WITHOUT_CATEGORY_VALUE);

    if (isSelected) {
      setCategorySelectedToCkeckBox([]);
    } else {
      setCategorySelectedToCkeckBox([WITHOUT_CATEGORY_VALUE]);
    }
  };

  if (isFetching || !newCategories) return <div>Loading...</div>;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.6rem',
        marginTop: '0.5rem',
      }}
      className="categoryTreeContainer"
    >
      {newCategories?.map((category) => (
        <CategoryTreeItem
          key={category._id}
          item={category}
          categorySelectedToCkeckBox={categorySelectedToCkeckBox}
          setCategorySelectedToCkeckBox={setCategorySelectedToCkeckBox}
          withoutCategoryValue={WITHOUT_CATEGORY_VALUE}
        />
      ))}

      <div
        style={{
          marginTop: '1rem',
          paddingTop: '0.8rem',
          borderTop: '1px solid #ddd',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
        }}
      >
        <input
          id="without-category"
          type="checkbox"
          checked={categorySelectedToCkeckBox?.includes(WITHOUT_CATEGORY_VALUE)}
          onChange={handleWithoutCategoryChange}
          style={{ cursor: 'pointer' }}
        />
        <label htmlFor="without-category" style={{ cursor: 'pointer', margin: 0 }}>
          Sin categoría
        </label>
      </div>
    </div>
  );
};